import { Textarea } from '@mantine/core';
import { ReactNode } from 'react';
import { FieldValues, useController } from 'react-hook-form';

import { FormControlInput } from '@/core/components';

export interface TextareaControlProps<T extends FieldValues> extends FormControlInput<T> {
  withAsterisk?: boolean;

  label: string;
  description?: string;
  placeholder?: string;

  isDisabled?: boolean;

  leftSection?: ReactNode;
  leftSectionWidth?: string;
}

export function TextareaControl<T extends FieldValues>(props: TextareaControlProps<T>) {
  const {
    withAsterisk,
    label,
    placeholder,
    description,
    name,
    isSubmitting,
    isDisabled,
    leftSection,
    leftSectionWidth,
    control,
  } = props;
  const {
    field,
    fieldState: { error },
  } = useController({ name, control });

  return (
    <Textarea
      ref={field.ref}
      name={field.name}
      value={field.value}
      onChange={field.onChange}
      label={label}
      description={description}
      placeholder={placeholder ?? label}
      withAsterisk={withAsterisk}
      error={error?.message}
      disabled={isSubmitting || isDisabled}
      autosize
      minRows={3}
      flex={1}
      leftSection={leftSection}
      leftSectionWidth={leftSectionWidth}
    />
  );
}
